import React, { useState } from "react";
import { useSelector } from "react-redux";
import { simpleGTMDataLayer } from "../../utils/utilities";
import "./Tooltip.css";

const Tooltip = (props: any) => {
    let timeout: any;
    const [active, setActive] = useState(false);
    const user = useSelector((state: any) => state.user)

    const showTip = () => {
        timeout = setTimeout(() => {
            simpleGTMDataLayer({
            csrId: user.userName,
                event: `Participant-Icon-Hover`,
                event_action: 'Hover Event',
                event_category: window.location.pathname,
                event_label: `Participant profile icon hover`,
                event_value: `${user.fullName} has hovered on ${props.content} icon`
            });
            simpleGTMDataLayer({
            csrId: user.userName,
                event: `Participant-Icon-Hover-Snowplow`,
                event_action: 'Hover Event',
                event_category: window.location.pathname + "/Snowplow",
                event_label: `Participant profile icon hover`,
                event_value: `${user.fullName} has hovered on ${props.content} icon`
            });
            setActive(true);
        }, props.delay || 400);
    };

    const hidetooltip = () => {
        clearInterval(timeout);
        setActive(false);
    };

    return (
        <div
            className="Tooltip-Wrapper"
            onMouseEnter={showTip}
            onMouseLeave={hidetooltip}
            data-testid="tooltip"
        >
            {React.cloneElement(props.children, { hidetooltip: hidetooltip })}
            <div style={{ ...props.styles }} className={`Tooltip-Tip ${props.direction || "bottom"} ${active ? " show" : ""}`}>
                {props.content}
            </div>
        </div>
    );
};

export default Tooltip;
